import { render } from "./Clinics.vue?vue&type=template&id=63b6ea0a&scoped=true"
import script from "./Clinics.vue?vue&type=script&lang=js"
export * from "./Clinics.vue?vue&type=script&lang=js"

import "./Clinics.vue?vue&type=style&index=0&id=63b6ea0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b6ea0a"]])

export default __exports__